export default "__VITE_ASSET__a4ad8430__"